import { useMemo, useState } from 'react';

import Button from '~components/Button';
import ModalBase, { ModalBaseProps } from '~components/ModalBase';
import CompanySectionTitle from '~features/company/CompanySectionTitle';
import { CareerType } from '~features/company/SalaryInfo/types';
import useGetCompanyInfo from '~hooks/query/company/useCompanyInfo';
import { COMPANYS_SOURCE_VALUE } from '~types/company';

import ModalNav from './components/ModalNav';
import SalariesByCorp from './components/SalariesByCorp';
import Summary from './components/Summary';
import WikiSalaryList from './components/WikiSalaryList';
import { getAmplitudeAttrbutes } from './helper';
import * as S from './style';

export interface Nav<T = string> {
  label: string;
  value: T;
}

interface SalaryData {
  min: number;
  max: number;
  avg: number;
  KJ: number;
  CORP: number;
}

export interface ModalSalaryInfoProps extends ModalBaseProps {
  companyId: string;
  title: string;
  navData: Nav[];
  prefix: CareerType;
  defaultMenuValue: string;
  labelExpectedSalary?: string;
  salaryData: Record<string, SalaryData>;
  companySource: COMPANYS_SOURCE_VALUE;
}

export default function ModalSalaryInfo({
  companyId,
  isOpen,
  handleClose,
  title,
  navData,
  prefix,
  defaultMenuValue,
  labelExpectedSalary = '예상연봉',
  salaryData,
  companySource,
}: ModalSalaryInfoProps) {
  const { data: companyInfo } = useGetCompanyInfo(companyId);
  const [currentMenu, setCurrentMenu] = useState<string>(defaultMenuValue);
  const handleClickNav = ({ value }: Nav) => {
    setCurrentMenu(value);
  };
  const dataAttributes = useMemo(() => {
    return getAmplitudeAttrbutes(prefix, navData);
  }, [prefix, navData]);

  const handleClickSalaryReport = () => {
    const career = prefix === '신입' ? 1 : 3;
    window.open(`/salaryreport/step?company=${companyId}&career=${career}`);
  };

  return (
    <ModalBase
      isOpen={isOpen}
      handleClose={handleClose}
      hasCloseButton
      inlineCss={S.cssModalContent}
      maskClosable>
      <S.Wrapper>
        <S.Header>
          <S.ModalTitle>{title}</S.ModalTitle>
        </S.Header>
        <ModalNav
          activeValue={currentMenu}
          navData={navData}
          onClick={handleClickNav}
          dataAttributes={dataAttributes}
        />
        <Summary label={labelExpectedSalary} salary={salaryData[currentMenu].avg} />
        <S.TitleGroup>
          <CompanySectionTitle>제보 내역</CompanySectionTitle>
          <Button
            size='sm'
            variant='dark'
            onClick={handleClickSalaryReport}
            data-attribute-id='company__salary__seeMore__details__salaryRank'
            data-company-id={companyInfo?.PK_NM_HASH}
            data-company-name={companyInfo?.name}>
            제보하기
          </Button>
        </S.TitleGroup>
        <SalariesByCorp
          corpSalary={salaryData[currentMenu].CORP}
          mlSalary={salaryData[currentMenu].KJ}
          companySource={companySource}
        />
        <WikiSalaryList prefix={prefix} companyId={companyId} category={currentMenu} />
      </S.Wrapper>
    </ModalBase>
  );
}
